import React, { useEffect, useState } from "react"
import PageTitle from "../components/PageTitle";
import Index from "../view/LocationDetail/Index";
import { useDispatch, useSelector } from "react-redux";
import ApiCall from "../common/ApiCall";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { generateSlug, getLangBySlug, getLinkNameByLang, getSlugByLang, getSlugNameByLang, isObjectEmpty } from "../common/Helper";
import HomeIcon from "../components/Iocns/HomeIcon";
import { setLanguage } from "../redux/user/user.action";

export default function LocationDetailController() {

    const [productList, setProductList] = useState([]);
    const [tourStyle, setTourStyle] = useState([]);
    const [locationDetail, setLocationDetail] = useState({});
    const [nextLocations, setNextLocations] = useState([]);
    const [nextTheme, setNextTheme] = useState({});
    const user = useSelector((state) => state.user);
    const global = useSelector((state) => state.global);
    const perems = useParams();
    const { "*": slug } = useParams();
    const [currentLocation, setCurrentLocation] = useState('');
    const location = useLocation()
    const navigate = useNavigate()
    const [breadcrumbList, setBreadcrumbList] = useState([])
    const [attractionNearNextPageUrl, setAttractionNearNextPageUrl] = useState('');
    const [tourStyleNextPageUrl, setTourStyleNextPageUrl] = useState('');


    const [isLoading, setIsLoading] = useState(false);
    const [isAttractionNearLoading, setIsAttractionNearLoading] = useState(false);
    const [isTourStyleLoading, setIsTourStyleLoading] = useState(false);
    const [isNextVacationLoading, setIsNextVacationLoading] = useState(false);
    const [nextLocationNextPageUrl, setNextLocationNextPageUrl] = useState('');
    const [destinationSuggetions, setDestinationSuggetions] = useState([]);
    const [activitiesSuggetion, setActivitiesSuggetion] = useState([]);
    const [productsSuggetion, setProductsSuggetion] = useState([]);
    const [searchValue, setSearchValue] = useState("");
    const [isSearchLoading, setIsSearchLoading] = useState(false);
    const [mapLoaded, setMapLoaded] = useState(false);
    const dispatch = useDispatch();
    const slugLinkField = getLinkNameByLang(user?.language)
    const slugNameField = getSlugNameByLang(user?.language)
    const slugLang = getSlugByLang(user?.language)
    const [isProductsLoading, setIsProductsLoading] = useState(false);
    const [isNextLoading, setIsNextLoading] = useState(false);
    const [isStyleLoading, setIsStyleLoading] = useState(false);




    function getParentHierarchy(obj) {
        let hierarchy = [];
        let current = obj; // Start from the object itself

        while (current) {
            hierarchy.unshift({
                name: current.name,
                link: current?.[slugLinkField],
            }); // Add object to the beginning
            current = current.parent; // Move up the hierarchy
        }

        return hierarchy;
    }


    const getLocationPageList = async (type = 'ALL', page = null, location) => {

        setProductList([])
        setTourStyle([])
        setNextLocations([])
        setBreadcrumbList([])

        let data = {}
        var slugField = "";
        let lang = getLangBySlug(perems?.lang)
        slugField = getSlugNameByLang(lang)
        if (user?.language != lang) {
            dispatch(setLanguage(lang))
        }

        data.location = location ? location : currentLocation;
        data.type = type;
        data.page = page;
        data.slug = slug
        data.field = slugField
        // if (user.token) {
        //     data.user_id = user.userDetails.id
        // } else {
        //     data.visitedList = global.visitedList
        // }

        setIsLoading(true)
        setIsProductsLoading(true)

        // if (type == 'ALL') {
        //     setIsLoading(true)
        // }
        // if (type == 'products') {
        //     setIsAttractionNearLoading(true)
        // }

        // if (type == 'tourStyle') {
        //     // data.tourStyle = JSON.stringify(tourStyle.map((item) => item.name))
        //     data.tourStyle = JSON.stringify(tourStyle.map((item) => item?.activity_theme?.name))
        //     setIsTourStyleLoading(true)
        // }

        // if (type == 'nextVacation') {
        //     data.nextVacation = JSON.stringify(nextLocations.map((item) => item.id))
        //     setIsNextVacationLoading(true)
        // }


        const getList = await ApiCall('post', 'location-detail-list', data)
        setIsLoading(false)
        // setIsProductsLoading(false)
        // setIsAttractionNearLoading(false)
        // setIsTourStyleLoading(false)
        // setIsNextVacationLoading(false)

        if (getList) {

            if (getList?.data?.success) {
                // console.log(getList.data);

                setLocationDetail(getList.data.data)

                setCurrentLocation(getList.data.data?.[slugNameField])


                window.history.replaceState(null, "", (slugLang ? ('/' + slugLang) : '') + '/location' + getList.data.data.locationDetail?.[slugLinkField]);

                let locD = getList?.data?.data
                let breadList = [{
                    name: <HomeIcon />,
                    url: (slugLang ? ('/' + slugLang) : '/')
                }];
                if (locD) {
                    let locHer = getParentHierarchy(locD)
                    if (locHer && locHer.length > 0) {
                        locHer.map((lh, key) => {
                            let link = (slugLang ? ('/' + slugLang) : '') + "/location" + lh.link
                            if (key + 1 == locHer.length) {
                                link = ""
                            }
                            breadList.push({ name: lh.name, url: link })

                        })
                        setBreadcrumbList(breadList)
                    }
                }


                // if (type == 'products') {
                //     setProductList(prevProducts => [...prevProducts, ...getList.data.data.products]);
                //     setAttractionNearNextPageUrl(getList.data.data.attraction_near_next_page_url)
                // }

                // if (type == 'tourStyle') {
                //     setTourStyle(prevProducts => [...prevProducts, ...getList.data.data.tourStyle]);
                //     setTourStyleNextPageUrl(getList.data.data.themes_next_page_url)
                // }


                // if (type == 'nextVacation') {
                //     setNextLocations(prevProducts => [...prevProducts, ...getList.data.data.locations]);
                //     setNextLocationNextPageUrl(getList.data.data.next_vacation_next_page_url)
                // }

            } else {
                // navigate('/')
            }
        } else {
            navigate(-1)
        }
    }

    const getLocationPageItemList = async (type = 'ALL', page = null) => {

        let data = {}

        data.location_id = locationDetail?.id
        data.type = type;
        data.page = page;
        data.parent_id = locationDetail?.parent_id;
        data.position = locationDetail?.position;
        data.childCount = locationDetail?.children_count;


        if (user.token) {
            data.user_id = user.userDetails.id
        } else {
            data.visitedList = global.visitedList
        }
        if (type == 'products') {
            data.alreadyLoadedIds = JSON.stringify(productList.map((item) => item?.id))
        }

        if (!page || page == 1) {
            if (type == 'products') {
                setProductList([])
                setIsProductsLoading(true)
            }
            if (type == 'tourStyle') {
                setTourStyle([])
                setIsNextLoading(true)
            }

            if (type == 'nextVacation') {
                setNextLocations([])
                setIsStyleLoading(true)
            }
        }

        if (type == 'products' && (page || page > 1)) {
            setIsAttractionNearLoading(true)
        }

        if (type == 'tourStyle' && (page || page > 1)) {

            // data.tourStyle = JSON.stringify(tourStyle.map((item) => item?.activity_theme?.name))
            data.tourStyle = JSON.stringify(tourStyle.map((item) => (item?.activity_theme?.name ? item?.activity_theme?.name : item?.name)))
            setIsTourStyleLoading(true)
        }

        if (type == 'nextVacation' && (page || page > 1)) {
            data.nextVacation = JSON.stringify(nextLocations.map((item) => item.id))
            setIsNextVacationLoading(true)
        }


        const getList = await ApiCall('post', 'location-product-list', data)
        setIsProductsLoading(false)
        setIsNextLoading(false)
        setIsAttractionNearLoading(false)
        setIsTourStyleLoading(false)
        setIsNextVacationLoading(false)
        setIsStyleLoading(false)


        if (getList) {

            if (getList?.data?.success) {

                if (type == 'products') {
                    setProductList(prevProducts => [...prevProducts, ...getList.data.data]);
                    setAttractionNearNextPageUrl(getList.data.next_page_url)
                }

                if (type == 'tourStyle') {
                    setTourStyle(prevProducts => [...prevProducts, ...getList.data.data.tourStyle]);
                    setTourStyleNextPageUrl(getList.data.data.themes_next_page_url)
                }


                if (type == 'nextVacation') {
                    setNextLocations(prevProducts => [...prevProducts, ...getList.data.data.locations]);
                    setNextLocationNextPageUrl(getList.data.data.next_vacation_next_page_url)
                }

            } else {
                // navigate('/')
            }
        } else {
            navigate(-1)
        }
    }

    useEffect(() => {
        (async () => {
            if (slug) {
                setLocationDetail({})
                const locationPath = slug ? slug.split('/') : [];
                let cL = locationPath[locationPath.length - 1];
                await getLocationPageList('ALL', null, cL)
                setCurrentLocation(cL)

            }
        })();


    }, [user.token, slug]);

    useEffect(() => {
        (async () => {
            if (locationDetail?.id) {
                await getLocationPageItemList('products', null)
                await getLocationPageItemList('nextVacation', null)
                await getLocationPageItemList('tourStyle', null)
            }
        })();


    }, [user.token, locationDetail]);

    useEffect(() => {





        // console.log(locationDetail?.link);
        // console.log(slug);
        // console.log(window.location.pathname?.replace(/^\/location/, ""));



        // if (locationDetail && locationDetail?.link && (locationDetail.link != ('/' + slug) || locationDetail.link != window.location.pathname?.replace(/^\/location/, ""))) {
        //     setCurrentLocation(locationDetail.slug)
        //     window.history.replaceState(null, "", '/location' + locationDetail.link);
        // }

        if (locationDetail?.slug) {
            setCurrentLocation(locationDetail?.slug)
        }


    }, [locationDetail?.slug]);


    const onClickLoadMore = async (type, page) => {
        await getLocationPageItemList(type, page)
    }


    const getSearchSuggetions = async (search) => {
        setIsSearchLoading(true)
        let data = {}
        data.search = search

        const recordList = await ApiCall('post', 'search-suggetions', data)
        setIsSearchLoading(false)
        if (recordList) {
            if (recordList?.data?.success) {


                setDestinationSuggetions(recordList.data.data.destinations)
                setActivitiesSuggetion(recordList.data.data.activities);
                setProductsSuggetion(recordList.data.data.products)
            }
        }
    };


    const handleKeyUp = async (e) => {
        const value = e.target.value;
        if (value.trim().length === 0) {
            setDestinationSuggetions([])
            setActivitiesSuggetion([])
            setProductsSuggetion([])
            // setSearchValue('');
        }
        if (value.trim().length >= 3) {
            await getSearchSuggetions(value)
        }
        // setSearchValue(value);
    };

    const onClickReset = () => {
        setSearchValue("");
        setDestinationSuggetions([])
        setActivitiesSuggetion([])
        setProductsSuggetion([])
    }

    const onClickDestination = (destination) => {
        let slug = generateSlug(destination)
        navigate('/search?location_name=' + slug)
    }

    const onClickActivity = (activity) => {
        // let slug = generateSlug(activity)
        navigate('/search?attraction=' + activity)
    }

    const onClickProduct = (slug) => {
        navigate(`/tour/${slug}`)

    }

    useEffect(() => {
        // Check if the script is already loaded to avoid loading it multiple times

        const script = document.createElement('script');
        script.src = 'https://cdn.trustindex.io/loader.js';
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);

        // Cleanup: Remove the script when the component is unmounted
        return () => {
            document.head.removeChild(script);
        };
    }, [productList]);


    const toggleMap = () => {
        const mapBox = document.querySelector(".mapBox");
        const button = document.querySelector(".btnMap");

        if (mapBox.style.opacity === "0") {
            mapBox.style.opacity = "1";
            mapBox.style.maxHeight = "300px";
            mapBox.style.display = "block";
            button.textContent = "Hide Map";
            setMapLoaded(true);
        } else {
            mapBox.style.opacity = "0";
            mapBox.style.maxHeight = "0";
            setTimeout(() => {
                mapBox.style.display = "none"; // Hide after transition
            }, 500);
            button.textContent = "Show Me In The Map";
        }
    };


    useEffect(() => {
        if (!isObjectEmpty(locationDetail)) {

            setCurrentLocation(locationDetail?.[slugNameField])

            window.history.replaceState(null, "", (slugLang ? ('/' + slugLang) : '') + '/location' + locationDetail?.[slugLinkField]);

            let locD = locationDetail
            let breadList = [{
                name: <HomeIcon />,
                url: (slugLang ? ('/' + slugLang) : '/')
            }];
            if (locD) {
                let locHer = getParentHierarchy(locD)
                if (locHer && locHer.length > 0) {
                    locHer.map((lh, key) => {
                        let link = (slugLang ? ('/' + slugLang) : '') + "/location" + lh.link
                        if (key + 1 == locHer.length) {
                            link = ""
                        }
                        breadList.push({ name: lh.name, url: link })

                    })
                    setBreadcrumbList(breadList)
                }
            }
        }
    }, [user?.language, locationDetail]);


    return (
        <>
            <PageTitle
                title={locationDetail?.meta_title || undefined}
                metaTitle={locationDetail?.meta_title || undefined}
                metaKeyword={locationDetail?.meta_keyword || undefined}
                metaDescription={locationDetail?.meta_description || undefined}
            />
            <Index
                productList={productList}
                isLoading={isLoading}
                tourStyle={tourStyle}
                locationDetail={locationDetail}
                // nextTheme={nextTheme}
                nextLocations={nextLocations}
                attractionNearNextPageUrl={attractionNearNextPageUrl}
                onClickLoadMore={onClickLoadMore}
                isAttractionNearLoading={isAttractionNearLoading}
                isProductsLoading={isProductsLoading}

                isTourStyleLoading={isTourStyleLoading}
                tourStyleNextPageUrl={tourStyleNextPageUrl}

                isNextLoading={isNextLoading}
                isStyleLoading={isStyleLoading}

                isNextVacationLoading={isNextVacationLoading}
                nextLocationNextPageUrl={nextLocationNextPageUrl}


                handleKeyUp={handleKeyUp}
                searchValue={searchValue}
                setSearchValue={setSearchValue}
                onClickReset={onClickReset}

                isSearchLoading={isSearchLoading}

                productsSuggetion={productsSuggetion}
                activitiesSuggetion={activitiesSuggetion}
                destinationSuggetions={destinationSuggetions}
                onClickProduct={onClickProduct}
                onClickDestination={onClickDestination}

                onClickActivity={onClickActivity}

                toggleMap={toggleMap}
                mapLoaded={mapLoaded}

                breadcrumbList={breadcrumbList}
            />
        </>
    )
}